import { render, staticRenderFns } from "./OrditAuthenticatedLayout.vue?vue&type=template&id=d1981af8&lang=pug&"
import script from "./OrditAuthenticatedLayout.vue?vue&type=script&lang=js&"
export * from "./OrditAuthenticatedLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports